meedy.factory('meedy.storedDocumentModel', ['$q','$rootScope', 'baseModel', 'meedy.storedDocumentService',
  function ($q,$rootScope, baseModel, storedDocumentService) {
	
	function StoredDocumentModel() {
	  this.getWpAnnex = function () {
		return storedDocumentService.getWpAnnex().then(
		  function (successResponse) {
			$rootScope.$broadcast(Event.MEEDY.STORED_DOCUMENT.GET_WP_ANNEX.SUCCESS, successResponse);
			return successResponse;
		  },
		  function (errorResponse) {
			$rootScope.$broadcast(Event.MEEDY.STORED_DOCUMENT.GET_WP_ANNEX.ERROR, errorResponse);
			return $q.reject(errorResponse);
		  }
		);
	  };
	  
	  this.setWpAnnex = function () {
		return storedDocumentService.setWpAnnex().then(
		  function (successResponse) {
			$rootScope.$broadcast(Event.MEEDY.STORED_DOCUMENT.SET_WP_ANNEX.SUCCESS, successResponse);
			return successResponse;
		  },
		  function (errorResponse) {
			$rootScope.$broadcast(Event.MEEDY.STORED_DOCUMENT.SET_WP_ANNEX.ERROR, errorResponse);
			return $q.reject(errorResponse);
		  }
		);
	  };
	  
	  this.wpAnnexAvailable = function () {
		return storedDocumentService.wpAnnexAvailable().then(
		  function (successResponse) {
			$rootScope.$broadcast(Event.MEEDY.STORED_DOCUMENT.WP_ANNEX_AVAILABLE.ERROR, successResponse);
			return successResponse;
		  },
		  function (errorResponse) {
			$rootScope.$broadcast(Event.MEEDY.STORED_DOCUMENT.WP_ANNEX_AVAILABLE.ERROR, errorResponse);
			return $q.reject(errorResponse);
		  }
		);
	  };
	}
	
	return new StoredDocumentModel();
  }
]);
